var h = Object.defineProperty;
var b = (s, e, n) => e in s ? h(s, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : s[e] = n;
var u = (s, e, n) => b(s, typeof e != "symbol" ? e + "" : e, n);
class A {
  constructor(e) {
    u(this, "logger", null);
    u(this, "events", /* @__PURE__ */ new Map());
    u(this, "publish", (e, n) => {
      var r;
      const t = this.getEventHandlers(e);
      (r = this.logger) == null || r.call(this, "event: ", "publish", `
eventName: `, e, `
params: `, n, `
handlers: `, t), t.forEach((i) => {
        i(n);
      });
    });
    u(this, "subscribe", (e, n) => {
      var r;
      return this.getEventHandlers(e).add(n), (r = this.logger) == null || r.call(this, "event: ", "subscribe", `
event: `, e, `
handler: `, n), () => {
        this.unsubscribe(e, n);
      };
    });
    u(this, "unsubscribe", (e, n) => {
      var r;
      const t = this.getEventHandlers(e);
      if ((r = this.logger) == null || r.call(this, "event: ", "unsubscribe", `
event: `, e, `
handler: `, n), t.size === 0) {
        t.clear();
        return;
      }
      t.delete(n);
    });
    this.logger = e != null ? e : null;
  }
  getEventHandlers(e) {
    let n = this.events.get(e);
    return n || (n = /* @__PURE__ */ new Set(), this.events.set(e, n)), n;
  }
}
function m(s) {
  return Array.isArray(s) ? s.length !== 0 : s != null && s !== "null";
}
class y extends Error {
}
function l(s, e) {
  if (!s)
    throw new y(e);
}
function a(s, e) {
  if (typeof s != typeof e)
    return !1;
  switch (typeof s) {
    case "boolean":
    case "string":
    case "function":
    case "symbol":
    case "undefined":
      return s === e;
    case "bigint":
    case "number":
      return Object.is(s, e);
    case "object": {
      if (l(typeof e == "object", "Assertation error"), s === null && e === null)
        return !0;
      if (s === null || e === null)
        return !1;
      const n = Array.isArray(s), t = Array.isArray(e);
      return n && t ? d(s, e) : n || t ? !1 : p(s, e);
    }
  }
  l(!1, "Assertation error");
}
function d(s, e) {
  if (s.length !== e.length) return !1;
  for (let n = 0; n < s.length; n++) {
    const t = s[n], r = e[n];
    if (!a(t, r))
      return !1;
  }
  return !0;
}
function p(s, e) {
  const n = Object.keys(s).sort(), t = Object.keys(e).sort();
  if (n.length !== t.length)
    return !1;
  for (let r = 0; r < n.length; r++) {
    const i = n[r], o = t[r];
    if (i !== o)
      return !1;
    const c = s[i], f = e[i];
    if (!a(c, f))
      return !1;
  }
  return !0;
}
async function E(s, e = 300) {
  return new Promise((n, t) => {
    setTimeout(() => {
      n(s());
    }, e);
  });
}
export {
  y as AssertionError,
  A as EventBus,
  l as assert,
  a as equalsDeep,
  m as hasValue,
  E as testRequestWithDelay
};
//# sourceMappingURL=utils.es.js.map
